export const isWx = () => {
  const ua = window.navigator.userAgent;
  return /micromessenger/i.test(ua);
};

export const isIOS = () => {
  const ua = window.navigator.userAgent;
  return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};

export const isAndroid = () => {
  const ua = window.navigator.userAgent;
  return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
};

export const isWindow = () => {
  let userAgent = window.navigator.userAgent.toLowerCase();
  // 用 test 匹配浏览器信息
  if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(userAgent)) {
      return false
  } else {
      return true
  }
};


// WEBPACK FOOTER //
// ./src/utils/ua.js